import $axios from '@/service/httpServer';
import $config from '@/config';
// 登陆相关
export const getVerify = p =>
  $axios.get('/auth/oasso/verifycode', p, {
    Authorization: $config.defaultAuthorization
  }); // 获取验证码
export const login = p =>
  $axios.postFormData('/auth/oauth/token', p, {
    Authorization: $config.defaultAuthorization
  }); // 登陆
export const loginLiuHe = p =>
  $axios.get('/auth/liuhe/code', p, {
    Authorization: $config.defaultAuthorization,
    _showCommonMsg: false
  });// 登陆
export const loginByOA = p =>
  $axios.postFormData('/auth/oasso/token', p, {
    Authorization: $config.defaultAuthorization
  }); // 登陆
export const loginByToken = () => $axios.get('/auth/user/token/details'); // 登陆
// 登陆
export const getUserPermission = p =>
  $axios.get('/auth/user/permissions', {
    appCode: $config.appCode,
    ...(p || {})
  }); // 获取用户权限列表
export const getUserInfo = () => $axios.get('/uc/personInfo/detail'); // 获取用户基本信息
export const logout = () => $axios.post('/auth/oauth/logout'); // 退出登陆

/**
 * 找回密码 ，重置密码相关
 */

//找回密码===》获取验证码
export const retrievePassGetAuthCode = p =>
  $axios.get('/upms/pass/retrievePass/getAuthCode', p);
//找回密码===》找回密码
export const retrievePassModifyPass = p =>
  $axios.post('/uc/account/find/pass', p);
//找回密码===》校验验证码
export const retrieveVerifyAndModify = p =>
  $axios.post('/upms/pass/retrievePass/verifyAndModify', p);

// 个人信息
export const getPersonal = p => $axios.get(`/uc/personInfo/detail?id=${p}`);
//个人信息-修改备注
export const personalRemark = p => $axios.post(`/upms/personInfo/remark`, p);
//个人信息-修改密码
export const personalModifyPass = p =>
  $axios.post(`/uc/account/update`, p);

/**
 * 切换令牌
 */
export const tokenCovert = clientId =>
  $axios.post('/auth/user/token/convert', { clientId: clientId }); // 切换令牌
